export function parseUrlSearchParams(searchParams?: string): Record<string, string> {
  // 如果没有传递 searchParams，则默认使用当前 URL 的 search 查询字符串
  if (!searchParams) {
    searchParams = window.location.search;
  }

  // 如果查询串不以 ? 开始，则补上 ?，方便后续解析
  if (searchParams.indexOf('?') !== 0) {
    searchParams = '?' + searchParams;
  }

  const searchParamsObject: Record<string, string> = {};

  try {
    // 使用 URLSearchParams 对象解析查询串
    const params = new URLSearchParams(searchParams);
    params.forEach((value, key) => {
      searchParamsObject[key] = value;
    });
  } catch {
    window.Slardar('sendEvent', {
      name: 'rd_URLSearchParams_error',
      categories: {},
    });
  }

  return searchParamsObject;
}

export const generateUrlSearch = (queryList: Record<string, string>) => {
  return Object.keys(queryList).reduce((previous, current, index) => {
    if (index) {
      previous += '&'
    }
    return `${previous}${current}=${queryList[current]}`
  }, '')
}

export const changeQuery = (params: Record<string, string>) => {
  const queryList = parseUrlSearchParams();
  Object.assign(queryList, params);
  return generateUrlSearch(queryList);
}

export const isAgreementPage = () => {
  const pathname = window.location.pathname;
  return pathname.includes('/agreement')
}

export const isModulesPage = () => {
  const queryList = parseUrlSearchParams();
  if (!queryList['from']) {
    return false;
  }
  return queryList['from'] === 'modules'
}
